import { useState } from '#imports'

/**
 * Actual rendered height of the page's bottom `RevStickyBar` (0 when
 * hidden), shared across scopes so other bottom-anchored UI (e.g. the
 * shopping assistant FAB) can clear it exactly instead of guessing a fixed
 * offset — the bar can grow taller depending on its content (e.g. a
 * flash-sale DealBanner on PDP).
 */
export const useStickyBarBottomOffset = () => {
  const stickyBarBottomHeight = useState('sticky-bar-bottom-height', () => 0)

  function setStickyBarBottomHeight(height: number) {
    stickyBarBottomHeight.value = height
  }

  return {
    stickyBarBottomHeight,
    setStickyBarBottomHeight,
  }
}
